import React from 'react'
import { createAutocomplete } from '@algolia/autocomplete-core';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import ProductItem from "../ProductListingComp/ProductItem";
import Popular from "../ProductListingComp/ProductMostPopular";
import "@algolia/autocomplete-theme-classic";
import { searchClient } from '@/utils/algolia-search-client';
import { generalConstants } from "@/utils/constants";
// const appId = process.env.ALGOLIA_APPLICATION_ID;
// const apiKey = process.env.ALGOLIA_SEARCH_API_KEY;
// const searchClient = algoliasearch(appId, apiKey);


function App(props) {
    // (1) Create a React state.
  
    const [autocompleteState, setAutocompleteState] = React.useState({});
    const autocomplete = React.useMemo(
        () =>
            createAutocomplete({
                openOnFocus: true,
                onStateChange({ state }) {
                    // (2) Synchronize the Autocomplete state with the React state.
                    setAutocompleteState(state);
                },

                getSources(setQuery, refresh, query) {

                    return [
                        // (3) Use an Algolia index source.
                        {
                            sourceId: 'products',
                            getItemInputValue({ item }) {
                                return item?.query;
                            },
                            getItems({ query }) {

                                return getAlgoliaResults({
                                    searchClient,

                                    queries: [
                                        {
                                            indexName: process.env.SHOPIFY_RECENTLY_ORDERED_INDEX,
                                            query,
                                            params: {
                                                hitsPerPage: 10,
                                                filters:`inventory_available:true OR product_type:'${generalConstants.gift_card_type}'`,
                                                attributesToSnippet: ['title:10'],
                                                snippetEllipsisText: '…',
                                            },
                                            transformResponse({ hits }) {
                                                return hits;
                                            },
                                        },
                                        
                                        {
                                            indexName: process.env.SHOPIFY_PRIMARY_INDEX,
                                            query,
                                            params: {
                                                hitsPerPage: 10,
                                                filters:`inventory_available:true OR product_type:'${generalConstants.gift_card_type}'`,
                                                attributesToSnippet: ['title:10'],
                                                snippetEllipsisText: '…',
                                                attributesToHighlight: [
                                                    'handle',
                                                    'title',
                                                    'vendor',
                                                    'options.color',
                                                    'tags'
                                                    
                                                    // '*', // returns all attributes in the index not just searchable attributes
                                                
                                                  ],
                                                  highlightPreTag:'<span class="search-highlight">',
                                                  highlightPostTag:'</span>',
                                            },
                                            
                                           
                                           
                                            transformResponse({ hits }) {
                                                return hits;
                                            },
                                        },

                                        {
                                            indexName: process.env.SHOPIFY_QUERY_SUGGESTIONS_INDEX,
                                            query,
                                            params: {
                                                hitsPerPage: 12,
                                                // attributesToSnippet: ['title:10'],
                                                // snippetEllipsisText: '…',
                                         
                                                attributesToHighlight: [
                                                    'query',
                                                    // '*', // returns all attributes in the index not just searchable attributes
                                                
                                                  ],
                                                highlightPreTag:'<span class="search-highlight">',
                                                highlightPostTag:'</span>'
                                            },
                                            transformResponse({ hits }) {

                                                return hits;
                                            },
                                        }
                                    ],
                                });
                            },
                            noResults() {
                                if(props.searchActive){
                                    return (
                                        <>
                                            <Popular query={query} />
                                        </>
                                    );
                                }
                                
                            },
                            getItemUrl({ item }) {
                                return item?.url;
                            },
                        },
                    ];
                },
            }),
        []
    );
    if(props.searchActive){
        return (
            <>
    
    
                <ProductItem className="aa-List"  {...autocomplete.getListProps()} setQuery={{ ...autocomplete.setQuery }} refresh={{ ...autocomplete.refresh }} autocomplete={autocomplete} autocompleteState={autocompleteState} handleSearchClick={props.handleSearchClick} searchActive={props.searchActive} />
    
            </>
        )
    }
    
}




export default App